"use client";
import { TextInput } from "../inputs/text-input";
import { useAsyncFieldValidation } from "@/hooks/useAsyncFieldValidation";

interface AsyncValidatedFieldProps {
  name: string;
  label: string;
  placeholder: string;
  endpoint: string;
  paramName: string;
  errorMessage: string;
  isMobile?: boolean;
  type?: string;
  autoComplete?: string;
  normalize?: (value: string) => string;
  isValueCheckable?: (value: string) => boolean;
}

export function AsyncValidatedField({
  name,
  label,
  placeholder,
  endpoint,
  paramName,
  errorMessage,
  isMobile,
  type = "text",
  autoComplete,
  normalize,
  isValueCheckable,
}: AsyncValidatedFieldProps) {
  const { isChecking } = useAsyncFieldValidation({
    fieldName: name,
    endpoint,
    paramName,
    errorMessage,
    normalize,
    isValueCheckable,
  });

  return (
    <TextInput
      name={name}
      label={label}
      type={type}
      size={isMobile ? "sm" : "lg"}
      placeholder={placeholder}
      autoComplete={autoComplete}
      isLoading={isChecking}
    />
  );
}
